<template>
  <!-- banner topo -->
  <div v-if="bannerTopo != ''" class="bannerTopo-area">
    <div class="bannerTopo-height d-flex align-items-center">

      <div class="bannerTopo-img">
        <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bannerTopo-bg-fill" alt="">
      </div>

      <div class="bannerTopo-overlay"></div>

      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 col-lg-10">
            <div class="bannerTopo-caption text-center">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- contato -->
  <section class="contact-section">
    <div class="container">

      <div class="row mb-5 pb-4">
        <div class="col-12">
          <h2 class="contact-title">Formulário de contato</h2>
        </div>

        <div class="col-lg-7 mb-30">
          <form class="form-contact contact_form" method="post" id="contactForm" novalidate="novalidate">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <textarea v-model="formulario.mensagem" class="form-control w-100" name="mensagem" id="mensagem"
                    cols="30" rows="9" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Digite sua mensagem'"
                    placeholder="Digite sua mensagem"></textarea>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-model="formulario.nome" class="form-control valid" name="nome" id="nome" type="text"
                    onfocus="this.placeholder = ''" onblur="this.placeholder = 'Seu nome'" placeholder="Seu nome">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <input v-model="formulario.email" class="form-control valid" name="email" id="email" type="email"
                    onfocus="this.placeholder = ''" onblur="this.placeholder = 'E-mail'" placeholder="E-mail">
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <input v-model="formulario.assunto" class="form-control" name="assunto" id="assunto" type="text"
                    onfocus="this.placeholder = ''" onblur="this.placeholder = 'Assunto'" placeholder="Assunto">
                </div>
              </div>
            </div>
            <div class="form-group mt-3 ">
              <button type="submit" @click.prevent="enviaremail()" class="button button-contactForm boxed-btn">Enviar
                contato</button>
            </div>
          </form>
        </div>

        <div v-if="contato != ''" class="col-lg-4 offset-lg-1">
          <div
            v-if="contato[0] && contato[0].itiResumo1 && contato[0].itiResumo1 !== '0' && contato[0].itiResumo1 !== '#'"
            class="media contact-info">
            <span class="contact-info__icon"><i class="fas fa-home"></i></span>
            <div class="media-body">
              <h3>Endereço</h3>
              <p v-html="contato[0].itiResumo1"></p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="fas fa-tablet-alt"></i></span>
            <div class="media-body">
              <h3>Telefones</h3>
              <p> {{ contato[0].itiCampoExtra3 }}</p>
              <p> {{ contato[0].itiCampoExtra4 }}</p>
            </div>
          </div>
          <div class="media contact-info">
            <span class="contact-info__icon"><i class="fas fa-envelope"></i></span>
            <div class="media-body">
              <h3>E-mail</h3>
              <p>{{ contato[0].itiReferencia }}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="contato.length > 0 && contato[0].itiCampoExtra6 && contato[0].itiCampoExtra6 !== '0' && contato[0].itiCampoExtra6 !== '#'" 
     class="d-none d-sm-block mb-5 pb-4">
  <iframe
    :src="'https://www.google.com/maps/embed?pb=' + contato[0].itiCampoExtra6"
    width="100%" 
    height="550" 
    style="border:0;" 
    allowfullscreen="" 
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade">
  </iframe>
</div>

    </div>
  </section>

</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';

export default {
  name: 'ContatoView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    contato: [],

    formulario: {
      nome: "",
      email: "",
      telefone: "",
      mensagem: ""
    }
  }),

  methods: {
    enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else {
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "Lukon",
          assunto: 'Contato do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiCampoExtra5,
          emailResposta: this.formulario.email,
          textoEmail:
            "Nome: " + this.formulario.nome + "<br>" +
            "E-mail: " + this.formulario.email + "<br>" +
            "Assunto: " + this.formulario.assunto + "<br>" +
            "Mensagem: " + this.formulario.mensagem,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: ''
        }
        axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
            if (response.data >= 1) {
              this.$mensagemSucesso("E-mail enviado com sucesso.")
              this.limparFormulario();
            }
          });
      }

    },

    limparFormulario() {
      this.formulario.nome = '';
      this.formulario.email = '';
      this.formulario.assunto = '';
      this.formulario.mensagem = '';
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Lukon :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

  },

  created() {
    this.carregaMetas("---");

    // TOPO BANNER
    axios.get('/Process/InsInstitucional/institucional/51/topocontato/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    //aqui busca contato
    axios.get('/Process/InsInstitucional/institucional/52/dadosdecontato/0/x')
      .then(response => {
        this.contato = response.data;
        //console.log('contato')
        //console.log(this.contato)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>